/* eslint-disable no-tabs */
import styled from 'styled-components';

export const Header = styled.header`
	width: 100%;
	display: flex;
	justify-content: space-between;
	margin-top: 16px;
`;
